webpackJsonp([47],{

/***/ 10:
/***/ (function(module, exports) {

module.exports = {"host":"","hostnlp":"http://172.20.44.193:5050"}

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FacebookLogin */
/* unused harmony export FacebookLogout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return refresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setToken; });
/* unused harmony export getLanguage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_production_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);






var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path;
var urlSecure = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure';



if (true) {
  var _url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path;
  var _urlSecure = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure';
}
var FacebookLogin = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/facebook/login', {
                token: token
              }).then(function (response) {
                resolve(response);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function FacebookLogin(_x) {
    return _ref.apply(this, arguments);
  };
}();

var FacebookLogout = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/facebook/logout').then(function (response) {
                localStorage.clear();
                resolve(response.data.data);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function FacebookLogout() {
    return _ref2.apply(this, arguments);
  };
}();
var forget = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(email) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("mail auth service", { email: email });
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/auth/forget', { email: email }).then(function (response) {
                resolve(response);
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err.response.data.errors);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: err.response.data.errors,
                  type: "danger"
                });
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function forget(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var login = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/auth/login', user).then(function (response) {
                localStorage.token = response.data.data.token;
                var token = localStorage.token;
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                resolve(response.data.data.user);
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err.response.data.errors);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: err.response.data.errors,
                  type: "danger"
                });
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function login(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var register = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(user) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            console.log("test userregister");
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/auth/register', user).then(function (response) {
                localStorage.token = response.data.data.token;
                var token = localStorage.token;
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                resolve(response.data.data.user);
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err.response.data.errors);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: err.response.data.errors,
                  type: "danger"
                });
              });
            }));

          case 2:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function register(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

var logout = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/auth/logout').then(function (response) {
                localStorage.clear();
                resolve(response);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function logout() {
    return _ref6.apply(this, arguments);
  };
}();

var getInfo = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(urlSecure + '/profile/info').then(function (response) {
                resolve(response.data.data);
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function getInfo() {
    return _ref7.apply(this, arguments);
  };
}();

var refresh = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (localStorage.token) {
                var token = localStorage.token;
                setToken(token);
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(urlSecure + '/profile/refresh').then(function (response) {
                  localStorage.token = response.data.data;
                  var token = localStorage.token;
                  setToken(token);
                  resolve(token);
                }).catch(function (err) {
                  return reject(err);
                });
              } else {
                reject('logout and login again');
              }
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function refresh() {
    return _ref8.apply(this, arguments);
  };
}();

var setToken = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['Authorization'] = 'Bearer ' + token;

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function setToken(_x5) {
    return _ref9.apply(this, arguments);
  };
}();

var getLanguage = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://restcountries.eu/rest/v1/all").then(function (response) {
                var countries = new Array();
                response.data.forEach(function (element) {
                  countries.push(element.name);
                });
                resolve(countries);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function getLanguage() {
    return _ref10.apply(this, arguments);
  };
}();

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// const ManageHome = () => import('@/components/Manage/manage.bot.template.vue')
var TicketComponent = function TicketComponent() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 345));
};
var AnnoucementsComponent = function AnnoucementsComponent() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 346));
};
var UserGuidComponent = function UserGuidComponent() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 347));
};
var ContactComponent = function ContactComponent() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 348));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next('/');
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'ticket',
  name: 'TicketComponent',
  meta: {
    title: 'support'
  },
  component: TicketComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'Annoucements',
  name: 'AnnoucementsComponent',
  meta: {
    title: 'support'
  },
  component: AnnoucementsComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'UserGuid',
  name: 'UserGuidComponent',
  meta: {
    title: 'support'
  },
  component: UserGuidComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'Contact',
  name: 'ContactComponent',
  meta: {
    title: 'support'
  },
  component: ContactComponent,
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth_service__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_users_service_js__ = __webpack_require__(55);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    currentUser: {}
  },
  getters: {
    getCurrentUser: function getCurrentUser(state) {
      return state.currentUser;
    }
  },
  mutations: {
    setCurrentUser: function setCurrentUser(state, user) {
      state.currentUser = user;
    }
  },
  actions: {
    setCurrentUser: function setCurrentUser(context, user) {
      context.commit('setCurrentUser', user);
    },
    forget: function forget(context, email) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("mail user store ", email);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth_service__["a" /* forget */])(email);

              case 3:
                usr = _context.sent;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    login: function login(context, user) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var usr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth_service__["c" /* login */])(user);

              case 2:
                usr = _context2.sent;

                context.commit('setCurrentUser', usr);
                return _context2.abrupt('return', usr);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    register: function register(context, user) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var usr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth_service__["f" /* register */])(user);

              case 2:
                usr = _context3.sent;

                context.commit('setCurrentUser', usr);
                return _context3.abrupt('return', usr);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    logout: function logout(context) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var usr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth_service__["d" /* logout */])();

              case 2:
                usr = _context4.sent;

                console.log('test logout ', usr);
                context.commit('setCurrentUser', usr);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    refresh: function refresh(context) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var token, user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth_service__["e" /* refresh */])();

              case 2:
                token = _context5.sent;
                _context5.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_auth_service__["b" /* getInfo */])(token);

              case 5:
                user = _context5.sent;

                context.commit("setCurrentUser", user);
                return _context5.abrupt('return', user);

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    updateUser: function updateUser(context, user) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var userUp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_users_service_js__["b" /* updateUserInfo */])(user);

              case 2:
                userUp = _context6.sent;

                context.commit('setCurrentUser', userUp);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        isHidden: function isHidden() {
            return this.getState();
        }
    },

    data: function data() {
        return {
            isHiddenLocalState: false
        };
    },


    methods: {
        close: function close() {
            if (this.remember) {
                localStorage.setItem('vue-bulma-notifications', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(true));
            }

            return this.isHiddenLocalState = true;
        },
        getState: function getState() {
            var savedState = localStorage.getItem('vue-bulma-notifications');

            return savedState && this.remember ? JSON.parse(savedState) : this.isHiddenLocalState;
        }
    },

    mounted: function mounted() {
        var _this = this;

        if (this.autoCloseAfter > 0) {
            setTimeout(function () {
                _this.isHidden = true;
            }, this.autoCloseAfter);
        }
    },


    props: {
        autoCloseAfter: {
            default: 0,
            type: Number
        },

        isCloseable: {
            default: true,
            type: Boolean
        },

        remember: {
            default: false,
            type: Boolean
        },

        type: {
            type: String,
            default: ''
        }
    }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  computed: {
    bot: function bot() {
      return this.$store.getters.getBot;
    },
    bots: function bots() {
      function compare(a, b) {
        if (a.date_Creat > b.date_Creat) return -1;
        if (a.date_Creat < b.date_Creat) return 1;
        return 0;
      }

      if (this.$store.getters.getAllBots && this.$store.getters.getAllBots && this.$store.getters.getAllBots.length > 0) {
        return this.$store.getters.getAllBots.sort(compare);
      } else {

        return this.$store.getters.getAllBots;
      }
    },
    botsAll: function botsAll() {
      var _this = this;

      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.bots.filter(function (el) {
        return el.name.toLowerCase().includes(_this.search.toLowerCase());
      }).sort(compare);
    },
    filterBySearchBot: function filterBySearchBot() {
      var _this2 = this;

      function compare(a, b) {
        if (a.date_Creat > b.date_Creat) return -1;
        if (a.date_Creat < b.date_Creat) return 1;
        return 0;
      }
      function compare2(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      function compare1(a, b) {
        if (a.name > b.name) return -1;
        if (a.name < b.name) return 1;
        return 0;
      }

      function compare3(a, b) {

        if (a.date_Creat < b.date_Creat) return -1;
        if (a.date_Creat > b.date_Creat) return 1;
        return 0;
      }
      function compare4(a, b) {
        if (a.date_Update > b.date_Update) return -1;
        if (a.date_Update < b.date_Update) return 1;
        return 0;
      }
      function compare5(a, b) {

        if (a.date_Update < b.date_Update) return -1;
        if (a.date_Update > b.date_Update) return 1;
        return 0;
      }
      if (this.filterDateUp) {
        console.log("########## compare");
        return this.bots.sort(compare);
      } else if (this.filterNameDown) {
        console.log("########## compare1");
        return this.bots.sort(compare1);
      } else if (this.filterNameUp) {
        console.log("########## compare2");
        return this.bots.filter(function (el) {
          return el.name.toLowerCase().includes(_this2.search.toLowerCase());
        }).sort(compare2);
        // return this.bots.sort(compare2);
      } else if (this.filterDateDown) {
        console.log("########## compare3");
        return this.bots.sort(compare3);
      } else if (this.filterUpdateUp) {
        console.log("########## compare4");
        return this.bots.sort(compare4);
      } else if (this.filterUpdateDown) {
        console.log("########## compare5");
        return this.bots.sort(compare5);
      } else {
        return this.bots.filter(function (el) {
          return el.name.toLowerCase().includes(_this2.search.toLowerCase());
        }).sort(compare);
        // return  this.bots.sort(compare)
      }
    }
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addExpression */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getConversationById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resultsfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return uploadffile; });
/* unused harmony export uploadFileExcel */
/* unused harmony export uploadImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAllConversationbyBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getConversationAll; });
/* unused harmony export getMessageConversation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getuttrnaceAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addMessage; });
/* unused harmony export removeConversation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateMessages; });
/* unused harmony export updateConversation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_production_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_service_js__ = __webpack_require__(12);







var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/conversation';
var url1 = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/expression';

var urlNLP = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.hostnlp;
var urlUp = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/file';



if (true) {
  url = __WEBPACK_IMPORTED_MODULE_6__config_production_json___default.a.host + path + '/conversation';
  url1 = __WEBPACK_IMPORTED_MODULE_6__config_production_json___default.a.host + path + '/secure/expression';
}

var addExpression = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(expression) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url1 + '/add', expression).then(function (response) {
                var newExpression = response.data.data;
                resolve(newExpression);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function addExpression(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getConversationById = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var conversation = response.data.data;
                resolve(conversation);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getConversation(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getConversationById(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var removeFile = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var propsData = {
                duration: 1500,
                direction: "right"
              };
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/remove/file/', obj).then(function (response) {

                resolve(response.data.data);
              }).catch(function (err) {});
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function removeFile(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var resultsfile = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(idbot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/api/files/getall/' + idbot).then(function (response) {
                // response.data.forEach(element => {
                // });
                resolve(response.data.data);
              }).catch(function (err) {});
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function resultsfile(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

// export async function uploadffile(formData, idbot,switche, domaine) {
//   return new Promise((resolve, reject) => {
//     let propsData = {
//       duration: 1500,
//       direction: "right",
//     }
//       axios.post(urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine, formData, {timeout: 600000}).then((respse) => {
//         // axios({
//         //   method: 'post',
//         //   url:urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine,
//         //   timeout: 600000, // Let's say you want to wait at least 6 mins
//         //   data:  formData,

//         // }).then((respse) => {
//         resolve(respse.data.data)
//       }).catch(err => {

//   })
// }

var uploadffile = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(formData, idbot, switche, domaine, typeUser) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var propsData = {
                duration: 1500,
                direction: "right"
              };
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/upload/batch/' + idbot + '/' + switche + '/' + domaine + '/' + typeUser, formData, { timeout: 600000 }).then(function (respse) {
                // axios({
                //   method: 'post',
                //   url:urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine,
                //   timeout: 600000, // Let's say you want to wait at least 6 mins
                //   data:  formData,

                // }).then((respse) => {
                resolve(respse.data.data);
              }).catch(function (err) {});
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function uploadffile(_x5, _x6, _x7, _x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();
// upload nrmlm tkoun fi upload file // serviceuploadfile intent
var uploadFileExcel = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(formData, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/upload/' + id, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function (response) {
                //  location.reload()
                resolve(response.data.data);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function uploadFileExcel(_x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();

var uploadImage = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(formData, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/image/' + id, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function (response) {
                resolve(response.data.data);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function uploadImage(_x12, _x13) {
    return _ref7.apply(this, arguments);
  };
}();

var getAllConversationbyBot = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/bot/get/' + id).then(function (response) {
                var conversation = response.data.data;

                resolve(conversation);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllConversationbyBot());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function getAllConversationbyBot(_x14) {
    return _ref8.apply(this, arguments);
  };
}();

var getConversationAll = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/all').then(function (response) {
                var conversations = response.data.data;
                resolve(conversations);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getConversationAll());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function getConversationAll() {
    return _ref9.apply(this, arguments);
  };
}();

var getMessageConversation = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id + '/message').then(function (response) {
                var messages = response.data.data;
                resolve(messages);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getMessageConversation(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function getMessageConversation(_x15) {
    return _ref10.apply(this, arguments);
  };
}();

function guidUtt() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var getuttrnaceAll = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(idBot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + idBot + '/all/messages').then(function (response) {

                var messages = response.data.data;
                resolve(messages);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getuttrnaceAll(idBot));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function getuttrnaceAll(_x16) {
    return _ref11.apply(this, arguments);
  };
}();

var addConversation = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(conv) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var obj = {
                bot: {
                  name: '',
                  _id: '',
                  switche: ''
                },
                participants: {
                  participantId: '',
                  username: '',
                  typeUser: ""
                },

                str: ''
              };
              obj.str = conv.messages.text;
              obj.bot.name = conv.nameBot;
              obj.bot._id = conv.botId;
              obj.bot.switche = conv.switche;
              obj.bot.domaine = conv.domaine;

              obj.typeUser = conv.typeUser;
              obj.participants.participantId = conv.participantId;
              obj.participants.username = conv.partciusername;
              var listUtee = [];
              var objj = {};
              // intt : "",
              // utt : ""
              //}
              var entit = {
                entity: "",
                entity_type: ""
              };
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/nlp', obj, {
                headers: {
                  'Content-type': 'application/JSON'
                }
              }).then(function (respse) {
                var resp = respse.data;

                if (resp === "Merci de cliquer d'abord sur Train") {
                  resolve(respse.data);
                } else if (resp && resp.length && resp.length > 1) {
                  resp.forEach(function (element, index) {

                    objj = {
                      intents: element.intent,
                      utterances: element.utterance,
                      DateEnv: Date.now(),
                      score: element.score,
                      language: element.sentiment.language,
                      uid: guidUtt()

                    };

                    listUtee.push(objj);

                    conv.messages.utterance = listUtee;

                    element.entities.forEach(function (le) {
                      conv.messages.entities.push(le.entity);
                    });
                    if (resp.length == index + 1) {
                      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add', conv).then(function (response) {

                        var newConver = response.data.data;
                        newConver.response = resp;
                        resolve(newConver);
                      });
                    }
                  });
                } else {
                  conv.messages.utterance.forEach(function (element) {
                    element.intents = resp[0].intent;
                    element.utterances = resp[0].utterance;
                    element.DateEnv = Date.now(), element.nature = "application";
                    element.language = resp[0].sentiment.language;
                    element.score = resp[0].score;
                  });
                  var listen = [];
                  if (resp[0].entities.length > 0) {
                    resp[0].entities.forEach(function (eleme, ind) {
                      if (typeof eleme['entity type'] == 'undefined') {
                        entit = {
                          entity: eleme.entity,
                          entity_type: "app"
                          // entit.entity = eleme.entity
                          //  entit.entity_type = eleme['entity type']
                        };listen.push(entit);
                      } else {
                        entit = {
                          entity: eleme.entity,
                          entity_type: eleme['entity type']
                          // entit.entity = eleme.entity
                          //  entit.entity_type = eleme['entity type']
                        };listen.push(entit);
                      }

                      if (ind + 1 == resp[0].entities.length) {
                        conv.messages.entities = listen;
                      }
                    });
                    //  conv.messages.entities = resp[0].entities[0].entity
                  } else {
                    conv.messages.entities = "None";
                  }

                  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add', conv).then(function (response) {

                    var newConver = response.data.data;
                    newConver.response = resp[0];
                    resolve(newConver);
                  }).catch(function (err) {
                    if (err.response.status === 401) {
                      Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                        resolve(addConversation(conv));
                      }).catch(function (err) {
                        return reject(err);
                      });
                    }
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function addConversation(_x17) {
    return _ref12.apply(this, arguments);
  };
}();

var addMessage = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(conv) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var obj = {
                bot: {
                  name: '',
                  _id: '',
                  switche: ''
                },
                str: ''

              };
              var entit = {
                entity: "",
                entity_type: ""
              };
              var listUtee = [];
              var objj = {};
              obj.str = conv.messages.text;
              obj.bot.name = conv.nameBot;
              obj.bot._id = conv.botId;
              obj.bot.switche = conv.switche;
              obj.typeUser = conv.typeUser;
              obj.domaine = conv.domaine;
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/nlp', obj, {
                headers: {
                  'Content-type': 'application/JSON'
                }
              }).then(function (respse) {
                var resp = respse.data;
                if (resp && resp.length && resp.length > 1) {
                  conv.messages.intents = [];
                  resp.forEach(function (element, index) {

                    objj = {
                      intents: element.intent,
                      utterances: element.utterance,
                      DateEnv: Date.now(),
                      score: element.score,
                      language: element.sentiment.language,
                      uid: guidUtt()
                    };

                    listUtee.push(objj);

                    conv.messages.utterance = listUtee;

                    element.entities.forEach(function (le) {
                      conv.messages.entities.push(le.entity);
                    });

                    if (resp.length == index + 1) {
                      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/' + conv._id + '/add/message', conv).then(function (response) {
                        var newConver = response.data.data;
                        newConver.response = resp;
                        resolve(newConver);
                      });
                    }
                  });
                } else {
                  var listen = [];
                  if (resp[0].entities.length > 0) {
                    resp[0].entities.forEach(function (eleme, ind) {
                      if (typeof eleme['entity type'] == 'undefined') {
                        // entit = {
                        //   entity : eleme.entity,
                        //   entity_type:"app"
                        // }
                        entit.entity = eleme.entity;
                        entit.entity_type = "app";
                        listen.push(entit);
                      } else {
                        // entit = {
                        //   entity : eleme.entity,
                        //   entity_type:eleme['entity type']
                        // }
                        entit.entity = eleme.entity;
                        entit.entity_type = eleme['entity type'];
                        listen.push(entit);
                      }

                      if (ind + 1 == resp[0].entities.length) {
                        conv.messages.entities = listen;
                      }
                    });
                    //  conv.messages.entities = resp[0].entities[0].entity
                  } else {
                    conv.messages.entities = "None";
                  }

                  conv.messages.language = resp[0].sentiment.language;
                  conv.messages.utterance.forEach(function (element) {
                    element.intents = resp[0].intent;
                    element.utterances = resp[0].utterance;
                    element.DateEnv = Date.now(), element.language = resp[0].sentiment.language;
                    element.score = resp[0].score;
                  });

                  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/' + conv._id + '/add/message', conv).then(function (response) {

                    var updateConver = response.data.data;
                    updateConver.response = resp[0];
                    resolve(updateConver);
                  }).catch(function (err) {
                    if (err.response.status === 401) {
                      Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                        resolve(addMessage(conv));
                      }).catch(function (err) {
                        return reject(err);
                      });
                    }
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function addMessage(_x18) {
    return _ref13.apply(this, arguments);
  };
}();

var removeConversation = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + id).then(function (response) {
                resolve(response);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(removeConversation(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function removeConversation(_x19) {
    return _ref14.apply(this, arguments);
  };
}();

var removeMessages = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(ids) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/remove/messages', ids).then(function (response) {
                resolve(response.data.data);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(removeMessages(ids));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function removeMessages(_x20) {
    return _ref15.apply(this, arguments);
  };
}();

var updateMessages = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/update/messagesIntent', obj).then(function (response) {
                var updateconv = response.data.data;
                resolve(updateconv);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(updateMessages(obj));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function updateMessages(_x21) {
    return _ref16.apply(this, arguments);
  };
}();

var updateConversation = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(id, conv) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + id, conv).then(function (response) {
                var updateconv = response.data.data;
                resolve(updateconv);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(updateConversation(id, conv));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function updateConversation(_x22, _x23) {
    return _ref17.apply(this, arguments);
  };
}();

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateUtteranceDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rahmaNLP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAlldashbordsbyBot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_production_json__);








var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/dashbord';
var urlUp = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/file';



if (true) {
  url = __WEBPACK_IMPORTED_MODULE_7__config_production_json___default.a.host + path + '/secure/dashbord';
}
var updateUtteranceDash = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(express) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejetc) {
              var obj = {
                intent: {
                  _id: '',
                  name: ''
                },
                _id: '',
                source: '',
                language: {
                  isocode: '',
                  _id: ''
                }
              };
              obj.intent = express.intent;
              obj.source = express.utt.source;
              obj.language = express.utt.language;
              obj._id = express.utt._id;
              var id = obj._id;
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + id, obj).then(function (response) {
                var expression = response.data.data;
                resolve(expression);
              }).catch(function (err) {
                return rejetc(err);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function updateUtteranceDash(_x) {
    return _ref.apply(this, arguments);
  };
}();

var rahmaNLP = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(idbot, namebot, traduction) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/rahmadash/' + idbot + '/' + namebot + '/' + traduction).then(function (response) {
                var dashbord = response.data.data;
                resolve(dashbord);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getIntentById(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function rahmaNLP(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getAlldashbordsbyBot = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/bot/get/' + id).then(function (response) {
                var dashboards = response.data.data;
                resolve(dashboards);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAlldashbordsbyBot());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getAlldashbordsbyBot(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getdomaine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getBotsByUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBotById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return forkBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trainBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateTrainBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return publishBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateBotSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateBotDomaine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_production_json__);







var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/bot';
var urlNLP = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.hostnlp;


if (true) {
  url = __WEBPACK_IMPORTED_MODULE_6__config_production_json___default.a.host + path + '/secure/bot';
}

var getdomaine = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/domainlist').then(function (response) {
                var res = response.data;
                var listDomaine = [];
                var i = 0;
                res.forEach(function (element, index) {
                  i = index;
                  listDomaine.push(element.domaine);
                });
                if (res.length === i + 1) {
                  resolve(listDomaine);
                }
              }).catch(function (err) {
                if (err.response.status == 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getdomaine());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getdomaine() {
    return _ref.apply(this, arguments);
  };
}();
var getBotsByUser = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/user/infoBots').then(function (response) {
                var bots = response.data.data;
                resolve(bots);
              }).catch(function (err) {
                if (err.response.status == 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getBotsByUser());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getBotsByUser() {
    return _ref2.apply(this, arguments);
  };
}();

var getBotById = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var bot = response.data.data;
                resolve(bot);
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getBotById(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var forkBot = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('test fork in service', url + '/fork');
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/fork/' + id).then(function (response) {
                console.log("teeest response data ", response);
                resolve(response.data.data);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function forkBot(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var trainBot = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('test obj ', obj);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/trainhamza', obj).then(function (respse) {
                console.log('test respse', respse);
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/train/' + obj._id).then(function (resp) {
                  resolve(resp.data.data);
                });
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err.response.data.errors);
                Vue.prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: err.response.data.errors,
                  type: "danger"
                });
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function trainBot(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var updateTrainBot = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("***********ipdate train", id);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/train/update/' + id).then(function (resp) {
                resolve(resp.data.data);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function updateTrainBot(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

var publishBot = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('tets obj', obj);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/publish', obj).then(function (response) {

                var urlpublish = {
                  text: response.data
                };
                console.log('test response', urlpublish);
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/publish/' + obj._id, urlpublish).then(function (resp) {
                  var botnews = resp.data.data;
                  console.log('test bot new', botnews);
                  resolve(botnews);
                });
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function publishBot(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

var addBot = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(bot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            console.log("################# bot add service ", bot);
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/creat', bot).then(function (response) {
                var bot = response.data.data;
                resolve(bot);
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function addBot(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

var deleteBot = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(bot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            console.log("bot name", bot);

            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var obj = {
                id: "",
                name: ""
              };
              bot.forEach(function (element) {
                obj = {
                  id: element._id,
                  name: element.name
                };
              });

              if (bot._id) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + _id).then(function (response) {
                  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/DeleteBot', obj).then(function (respse) {
                    console.log('test respse', respse);
                    var bots = response.data.data.bot;
                    resolve(response.data.data);
                  });
                }).catch(function (err) {
                  return reject(err);
                });
              } else {
                console.log(bot);
                bot.forEach(function (el) {
                  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/DeleteBot', obj).then(function (respse) {
                    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + el._id).then(function (response) {

                      console.log('test respse', respse);

                      var bots = response.data.data.bot;
                      resolve(response.data.data);
                    });
                  }).catch(function (err) {
                    return reject(err);
                  });
                });
              }
            }));

          case 2:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function deleteBot(_x7) {
    return _ref9.apply(this, arguments);
  };
}();
var updateBot = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(bot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            console.log("########## update servie ###########", bot);
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + bot._id, bot).then(function (response) {
                resolve(response);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function updateBot(_x8) {
    return _ref10.apply(this, arguments);
  };
}();
var updateBotSwitch = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(bot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            console.log("########## update servie ###########", bot);
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/switch/update/', bot).then(function (response) {
                console.log("################### response", response);
                resolve(response);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function updateBotSwitch(_x9) {
    return _ref11.apply(this, arguments);
  };
}();
var updateBotDomaine = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(bot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            console.log("########## update servie ###########", bot);
            return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/domaine/update/', bot).then(function (response) {
                console.log("################### response", response);
                resolve(response);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function updateBotDomaine(_x10) {
    return _ref12.apply(this, arguments);
  };
}();

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contactMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_production_json__);






var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path;
var urlSecure = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/contacter';


if (true) {
  url = __WEBPACK_IMPORTED_MODULE_5__config_production_json___default.a.host + path + '/contacter';
}
var contactMessage = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(contact) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:

            console.log("############# test contact #################", contact);
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("je suis dans le service contact", contact);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlSecure + '/add', contact).then(function (response) {
                console.log("je suis dans le service response.data.data.contact", response.data.data);

                var contact = response.data.data;
                resolve(contact);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function contactMessage(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIntentById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAllIntentsbyBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAllIntentsPublic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addIntentListPublic; });
/* unused harmony export addIntentPublic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addIntent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateIntent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteIntent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return uploadFileExcel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_production_json__);








var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/intent';
var urlUp = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/file';



if (true) {
  url = __WEBPACK_IMPORTED_MODULE_7__config_production_json___default.a.host + path + '/secure/intent';
}

var getIntentById = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var intent = response.data.data;
                resolve(intent);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getIntentById(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getIntentById(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getAllIntentsbyBot = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/bot/get/' + id).then(function (response) {
                var intents = response.data.data;
                resolve(intents);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllIntentsbyBot());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getAllIntentsbyBot(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getAllIntentsPublic = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/intentall/public').then(function (response) {
                var intents = response.data.data;
                resolve(intents);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllIntentsPublic());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getAllIntentsPublic() {
    return _ref3.apply(this, arguments);
  };
}();
var addIntentListPublic = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(intent) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            console.log("servicce add public intent ", intent);
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              intent.intent.slug = intent.intent.name.toLowerCase();
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add/public', intent).then(function (response) {
                var intent = response.data.data;
                resolve(intent);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function addIntentListPublic(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
var addIntentPublic = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(intent) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              intent.slug = intent.name.toLowerCase();
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/publicintent/add', intent).then(function (response) {
                var intent = response.data.data;
                resolve(intent);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function addIntentPublic(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
var addIntent = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(intent) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              intent.slug = intent.name.toLowerCase();
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add', intent).then(function (response) {
                var intent = response.data.data;
                resolve(intent);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function addIntent(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var updateIntent = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(intent) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + intent._id, intent).then(function (response) {
                var upIntent = response.data.data;

                resolve(upIntent);
              }).catch(function (err) {
                console.log('test err', err.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function updateIntent(_x6) {
    return _ref7.apply(this, arguments);
  };
}();

var deleteIntent = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(intent) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (intent._id) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + id).then(function (response) {
                  resolve(response.data.data);
                }).catch(function (err) {
                  return reject(err);
                });
              } else {
                console.log(intent);
                intent.forEach(function (el) {
                  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + el._id).then(function (response) {
                    resolve(response.data.data);
                  }).catch(function (err) {
                    return reject(err);
                  });
                });
              }
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function deleteIntent(_x7) {
    return _ref8.apply(this, arguments);
  };
}();

// upload nrmlm tkoun fi upload file // serviceuploadfile intent
var uploadFileExcel = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(formData, id, language) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/upload/' + id + '/intents/' + language.isocode, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function (response) {

                console.log('tetst res', response.data.data);
                //  location.reload()


                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                if (response.data.data === "files printed successfully") {
                  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$notif.show(propsData = {

                    title: "Success",
                    message: response.data.data,
                    type: "success"
                  });
                } else {
                  console.log("response.data.data", response.data.data);
                  __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$notif.show(propsData = {
                    title: "Error !",
                    message: response.data.data,
                    type: "danger"
                  });
                }

                resolve(response.data.data);
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err);
                __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: "Check your list intent Maybe this intent exist  !",
                  type: "danger"
                });
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function uploadFileExcel(_x8, _x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}();

// export async function deleteSynonym(obj){
//   return new Promise((resolve, reject) => {
//     let id = obj._id
//     axios.delete(url + '/remove/' + id, obj).then((response) => {
//       let updateIntent = response.data.data
//       resolve(updateIntent)
//     }).catch(err => reject(err))
//   })
// }

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getExpressionById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAllExpressionByIntents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAllExpressionBybot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAllExpression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addExpression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeUtterance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateUtterance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddListUtterance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return uploadFileExcelExpression; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_production_json__);







var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/expression';
var urlUp = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/file';


if (true) {
  url = __WEBPACK_IMPORTED_MODULE_7__config_production_json___default.a.host + path + '/secure/expression';
}

var getExpressionById = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var expression = response.data.data;
                resolve(expression);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getExpressionById(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getExpressionById(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getAllExpressionByIntents = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/intent/' + id + '/all').then(function (response) {
                var listExpression = response.data.data;
                resolve(listExpression);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllExpressionByIntents());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getAllExpressionByIntents(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getAllExpressionBybot = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/intentBot/' + id + '/all').then(function (response) {
                var listExpression = response.data.data;

                resolve(listExpression);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllExpressionBybot());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getAllExpressionBybot(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var getAllExpression = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/all').then(function (response) {
                var expressions = response.data.data;
                console.log("teeeeeeeeeest", expressions);
                resolve(expressions);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllExpression());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getAllExpression() {
    return _ref4.apply(this, arguments);
  };
}();

var addExpression = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(expression) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            console.log("test add new exp", expression);
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add', expression).then(function (response) {
                var newExpression = response.data.data;
                console.log('testadd new ecpr', newExpression);
                resolve(newExpression);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function addExpression(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

var removeUtterance = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(intent) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              console.log("############# service utterance", intent);
              // if (intent._id) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/remove/expression', intent).then(function (response) {
                console.log("########### resultat service", response.data.data);
                resolve(response.data.data);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function removeUtterance(_x5) {
    return _ref6.apply(this, arguments);
  };
}();

var updateUtterance = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(express) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejetc) {
              var obj = {
                intent: {
                  _id: '',
                  name: ''
                },
                _id: '',
                source: '',
                language: {
                  isocode: '',
                  _id: ''
                }
              };
              obj.intent = express.intent;
              obj.source = express.utt.source;
              obj.language = express.utt.language;
              obj._id = express.utt._id;
              var id = obj._id;
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + id, obj).then(function (response) {
                var expression = response.data.data;
                resolve(expression);
              }).catch(function (err) {
                return rejetc(err);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function updateUtterance(_x6) {
    return _ref7.apply(this, arguments);
  };
}();

var AddListUtterance = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(utrs) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('test service utterances', utrs);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add/list', utrs).then(function (response) {
                console.log("test response.data.data", response);
                var utrsExp = response.data.data;

                resolve(utrsExp);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function AddListUtterance(_x7) {
    return _ref8.apply(this, arguments);
  };
}();

var uploadFileExcelExpression = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(formData, id, intentId, intentName) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("************** urlUp", urlUp + '/upload/' + id + '/expression/' + intentId + '/' + intentName + '/');
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/upload/' + id + '/expression/' + intentId + '/' + intentName, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function (response) {

                console.log('tetst res', response.data.data);
                //  location.reload()


                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                if (response.data.data === "files printed successfully") {
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {

                    title: "Success",
                    message: response.data.data,
                    type: "success"
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                    title: "Error !",
                    message: response.data.data,
                    type: "danger"
                  });
                }

                resolve(response.data.data);
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: "Check your list expression Maybe this expression exist  !",
                  type: "danger"
                });
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function uploadFileExcelExpression(_x8, _x9, _x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDefaultEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEntityById; });
/* unused harmony export getAllEntities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAllEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAllEntitiesByBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAllSynonyms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addSynonyms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_production_json__);








var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/entity';
var urlNLP = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.hostnlp;


if (true) {
  url = __WEBPACK_IMPORTED_MODULE_7__config_production_json___default.a.host + path + '/secure/entity';
}
var getDefaultEntities = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("############# obj##########", obj);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlNLP + '/nlp', obj, {
                headers: {
                  'Content-type': 'application/JSON'
                }
              }).then(function (respse) {
                var resp = respse.data;
                resolve(resp);
              }).catch(function (err) {
                console.log('test err \n', err);reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getDefaultEntities(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getEntityById = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var entity = response.data.data;
                resolve(entity);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getEntityById());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getEntityById(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getAllEntities = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/all').then(function (response) {
                var entities = response.data.data;
                resolve(entities);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllEntities());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getAllEntities() {
    return _ref3.apply(this, arguments);
  };
}();
var getAllEntity = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/all').then(function (response) {
                var entities = response.data.data;
                resolve(entities);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllEntity());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getAllEntity() {
    return _ref4.apply(this, arguments);
  };
}();

var getAllEntitiesByBot = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/all/' + id).then(function (response) {
                var entities = response.data.data;
                resolve(entities);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_5__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllEntitiesByBot(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getAllEntitiesByBot(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var getAllSynonyms = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(idBot) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + idBot + '/all/synonyms').then(function (response) {
                var synonyms = response.data.data;
                console.log("######### response data ##", synonyms);
                resolve(synonyms);
              }).catch(function (err) {
                if (err.response.status == 401) {
                  resfesh().then(function () {
                    resolve(synonyms);
                  }).catcht(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function getAllSynonyms(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
var addEntity = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(entity) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              entity.slug = entity.name.toLowerCase();
              console.log("########## servie add entity", entity);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add', entity).then(function (response) {
                var entityNew = response.data.data;

                resolve(entityNew);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function addEntity(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

var addSynonyms = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(children) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            console.log('My beautiful children <3', children);
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/synonyms/add', children).then(function (response) {
                var entity = response.data.data[0];
                resolve(entity);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 2:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function addSynonyms(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

var addContent = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(children) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("############ debut service #########", children);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/content/add', children).then(function (response) {
                console.log('##########response.data.data', response.data.data);
                if (response.data.data == "This value exist") {
                  var propsData = {
                    direction: "right",
                    duration: 1500
                  };
                  __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                    title: "Error !",
                    message: "Please check your list maybe this value exist",
                    type: "danger"
                  });
                } else {
                  var entity = response.data.data;
                  resolve(entity);
                }
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function addContent(_x7) {
    return _ref9.apply(this, arguments);
  };
}();

var deleteContent = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(child) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/content/remove', child).then(function (response) {
                var child = response.data.data;
                resolve(child);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function deleteContent(_x8) {
    return _ref10.apply(this, arguments);
  };
}();

var deleteEntity = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(entities) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (entities._id) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + id).then(function (response) {
                  resolve(response.data.data);
                }).catch(function (err) {
                  return reject(err);
                });
              } else {
                console.log(entities);
                entities.forEach(function (el) {
                  __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url + '/remove/' + el._id).then(function (response) {
                    resolve(response.data.data);
                  }).catch(function (err) {
                    return reject(err);
                  });
                });
              }
            }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function deleteEntity(_x9) {
    return _ref11.apply(this, arguments);
  };
}();

var updateEntity = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(entity) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + entity._id, entity).then(function (response) {
                var upEntity = response.data.data;
                console.log('############ upEntity service ', upEntity);
                resolve(upEntity);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function updateEntity(_x10) {
    return _ref12.apply(this, arguments);
  };
}();

var updateContent = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(child) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/content/update', child).then(function (response) {
                var child = response.data.data;

                resolve(child);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function updateContent(_x11) {
    return _ref13.apply(this, arguments);
  };
}();

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_css__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sass_main_sass__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sass_main_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__sass_main_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_Notification_notifcation_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_mixin_bot_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_tel_input__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_progressbar__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuejs_progress_bar__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuejs_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuejs_progress_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vuejs_progress_bar___default.a);
var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_11__components_Shared_Notification_notifcation_vue__["a" /* default */]);
var options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'left',
  inverse: false
};

__WEBPACK_IMPORTED_MODULE_8__fortawesome_fontawesome_svg_core__["library"].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_solid_svg_icons__["a" /* faCoffee */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_progressbar___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('notification', __webpack_require__(318));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_tel_input__["b" /* default */]);
// Custom modal with Bulma :3
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use({
  install: function install(vue) {
    vue.prototype.$hyModal = {
      hide: function hide(id) {
        document.getElementById(id).classList.remove('is-active');
      },
      show: function show(id) {
        document.getElementById(id).classList.add('is-active');
      }
    }, vue.prototype.$notif = {
      show: function show(propsData) {
        return new NotificationComponent({
          el: document.createElement('div'),
          propsData: propsData
        });
      }
      // vue.prototype.$entityManage = {
      //   click: function(propDatass){        
      //     let instance = new EntityManageComponent({
      //       el: document.createElement('div'),
      //       propDatass
      //     })
      //     instance.$slots.default = ['Click me!']
      //     instance.$mount() // pass nothing
      //     console.log('test instanxe ', instance)
      //     return this.$refs.container.appendChild(instance.$el)
      //   }
      // }
    };
  }
});

// 




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_16_moment___default()(String(value)).format('DD/MM/YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
  id: 'UA-159648158-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  mixin: [__WEBPACK_IMPORTED_MODULE_12__mixins_mixin_bot_js__["a" /* default */]],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3041405c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(276);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3041405c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 227:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 70,
	"./af.js": 70,
	"./ar": 71,
	"./ar-dz": 72,
	"./ar-dz.js": 72,
	"./ar-kw": 73,
	"./ar-kw.js": 73,
	"./ar-ly": 74,
	"./ar-ly.js": 74,
	"./ar-ma": 75,
	"./ar-ma.js": 75,
	"./ar-sa": 76,
	"./ar-sa.js": 76,
	"./ar-tn": 77,
	"./ar-tn.js": 77,
	"./ar.js": 71,
	"./az": 78,
	"./az.js": 78,
	"./be": 79,
	"./be.js": 79,
	"./bg": 80,
	"./bg.js": 80,
	"./bm": 81,
	"./bm.js": 81,
	"./bn": 82,
	"./bn.js": 82,
	"./bo": 83,
	"./bo.js": 83,
	"./br": 84,
	"./br.js": 84,
	"./bs": 85,
	"./bs.js": 85,
	"./ca": 86,
	"./ca.js": 86,
	"./cs": 87,
	"./cs.js": 87,
	"./cv": 88,
	"./cv.js": 88,
	"./cy": 89,
	"./cy.js": 89,
	"./da": 90,
	"./da.js": 90,
	"./de": 91,
	"./de-at": 92,
	"./de-at.js": 92,
	"./de-ch": 93,
	"./de-ch.js": 93,
	"./de.js": 91,
	"./dv": 94,
	"./dv.js": 94,
	"./el": 95,
	"./el.js": 95,
	"./en-au": 96,
	"./en-au.js": 96,
	"./en-ca": 97,
	"./en-ca.js": 97,
	"./en-gb": 98,
	"./en-gb.js": 98,
	"./en-ie": 99,
	"./en-ie.js": 99,
	"./en-il": 100,
	"./en-il.js": 100,
	"./en-nz": 101,
	"./en-nz.js": 101,
	"./eo": 102,
	"./eo.js": 102,
	"./es": 103,
	"./es-do": 104,
	"./es-do.js": 104,
	"./es-us": 105,
	"./es-us.js": 105,
	"./es.js": 103,
	"./et": 106,
	"./et.js": 106,
	"./eu": 107,
	"./eu.js": 107,
	"./fa": 108,
	"./fa.js": 108,
	"./fi": 109,
	"./fi.js": 109,
	"./fo": 110,
	"./fo.js": 110,
	"./fr": 111,
	"./fr-ca": 112,
	"./fr-ca.js": 112,
	"./fr-ch": 113,
	"./fr-ch.js": 113,
	"./fr.js": 111,
	"./fy": 114,
	"./fy.js": 114,
	"./gd": 115,
	"./gd.js": 115,
	"./gl": 116,
	"./gl.js": 116,
	"./gom-latn": 117,
	"./gom-latn.js": 117,
	"./gu": 118,
	"./gu.js": 118,
	"./he": 119,
	"./he.js": 119,
	"./hi": 120,
	"./hi.js": 120,
	"./hr": 121,
	"./hr.js": 121,
	"./hu": 122,
	"./hu.js": 122,
	"./hy-am": 123,
	"./hy-am.js": 123,
	"./id": 124,
	"./id.js": 124,
	"./is": 125,
	"./is.js": 125,
	"./it": 126,
	"./it.js": 126,
	"./ja": 127,
	"./ja.js": 127,
	"./jv": 128,
	"./jv.js": 128,
	"./ka": 129,
	"./ka.js": 129,
	"./kk": 130,
	"./kk.js": 130,
	"./km": 131,
	"./km.js": 131,
	"./kn": 132,
	"./kn.js": 132,
	"./ko": 133,
	"./ko.js": 133,
	"./ky": 134,
	"./ky.js": 134,
	"./lb": 135,
	"./lb.js": 135,
	"./lo": 136,
	"./lo.js": 136,
	"./lt": 137,
	"./lt.js": 137,
	"./lv": 138,
	"./lv.js": 138,
	"./me": 139,
	"./me.js": 139,
	"./mi": 140,
	"./mi.js": 140,
	"./mk": 141,
	"./mk.js": 141,
	"./ml": 142,
	"./ml.js": 142,
	"./mn": 143,
	"./mn.js": 143,
	"./mr": 144,
	"./mr.js": 144,
	"./ms": 145,
	"./ms-my": 146,
	"./ms-my.js": 146,
	"./ms.js": 145,
	"./mt": 147,
	"./mt.js": 147,
	"./my": 148,
	"./my.js": 148,
	"./nb": 149,
	"./nb.js": 149,
	"./ne": 150,
	"./ne.js": 150,
	"./nl": 151,
	"./nl-be": 152,
	"./nl-be.js": 152,
	"./nl.js": 151,
	"./nn": 153,
	"./nn.js": 153,
	"./pa-in": 154,
	"./pa-in.js": 154,
	"./pl": 155,
	"./pl.js": 155,
	"./pt": 156,
	"./pt-br": 157,
	"./pt-br.js": 157,
	"./pt.js": 156,
	"./ro": 158,
	"./ro.js": 158,
	"./ru": 159,
	"./ru.js": 159,
	"./sd": 160,
	"./sd.js": 160,
	"./se": 161,
	"./se.js": 161,
	"./si": 162,
	"./si.js": 162,
	"./sk": 163,
	"./sk.js": 163,
	"./sl": 164,
	"./sl.js": 164,
	"./sq": 165,
	"./sq.js": 165,
	"./sr": 166,
	"./sr-cyrl": 167,
	"./sr-cyrl.js": 167,
	"./sr.js": 166,
	"./ss": 168,
	"./ss.js": 168,
	"./sv": 169,
	"./sv.js": 169,
	"./sw": 170,
	"./sw.js": 170,
	"./ta": 171,
	"./ta.js": 171,
	"./te": 172,
	"./te.js": 172,
	"./tet": 173,
	"./tet.js": 173,
	"./tg": 174,
	"./tg.js": 174,
	"./th": 175,
	"./th.js": 175,
	"./tl-ph": 176,
	"./tl-ph.js": 176,
	"./tlh": 177,
	"./tlh.js": 177,
	"./tr": 178,
	"./tr.js": 178,
	"./tzl": 179,
	"./tzl.js": 179,
	"./tzm": 180,
	"./tzm-latn": 181,
	"./tzm-latn.js": 181,
	"./tzm.js": 180,
	"./ug-cn": 182,
	"./ug-cn.js": 182,
	"./uk": 183,
	"./uk.js": 183,
	"./ur": 184,
	"./ur.js": 184,
	"./uz": 185,
	"./uz-latn": 186,
	"./uz-latn.js": 186,
	"./uz.js": 185,
	"./vi": 187,
	"./vi.js": 187,
	"./x-pseudo": 188,
	"./x-pseudo.js": 188,
	"./yo": 189,
	"./yo.js": 189,
	"./zh-cn": 190,
	"./zh-cn.js": 190,
	"./zh-hk": 191,
	"./zh-hk.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar-component'),_vm._v(" "),_c('div',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_router_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bot_router_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__doc_router_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__support_router_js__ = __webpack_require__(194);


var HomeDesktop = function HomeDesktop() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 363));
};
var HomeMobile = function HomeMobile() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 364));
};
var Init = function Init() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 365));
};
var Documentation = function Documentation() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 366));
};
var BotIndex = function BotIndex() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 367));
};
var ProfileTemplate = function ProfileTemplate() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 368));
};
var SupportTemplate = function SupportTemplate() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 213));
};
//const AuthFogetpaswword = () =>import('@/components/Shared/Auth/forget.password.component.vue')
var NewsLetterTemplate = function NewsLetterTemplate() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 324));
};






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next();
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  hashbang: false,
  routes: [{
    path: '/',
    name: 'Root',
    component: Init
  }, {
    path: '/Home',
    name: 'Home',
    component: HomeDesktop,
    meta: {
      title: 'Home - Application Msl Bot'
    },
    beforeEnter: ifAuthenticated
  }, {
    path: '/Home',
    component: HomeDesktop,
    children: [{
      meta: {
        showModal: true
      },
      path: '/NewsLetter',
      component: NewsLetterTemplate,
      props: true
    }]
  },
  // {
  //   path: '/NewsLetter',
  //   name: 'NewsLetter',
  //   component: NewsLetterTemplate,
  //   meta:{
  //     title: 'Home - News Letter'
  //   },
  //   beforeEnter: ifAuthenticated
  // },
  {
    path: '/HomeMobile',
    name: 'HomeMobile',
    component: HomeMobile,
    meta: {
      title: 'HomeMobile - Application Msl Bot'
    },
    beforeEnter: ifAuthenticated
  }, {
    path: '/documentation',
    component: Documentation,
    meta: {
      title: 'Home - documentation'
    },
    children: __WEBPACK_IMPORTED_MODULE_4__doc_router_js__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/user/setting',
    component: ProfileTemplate,
    meta: {
      title: 'Setting Account - Application Msl Bot'
    },
    children: __WEBPACK_IMPORTED_MODULE_2__user_router_js__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/application',
    component: BotIndex,
    meta: {
      title: 'List Bot - Application Msl Bot'
    },
    children: __WEBPACK_IMPORTED_MODULE_3__bot_router_js__["a" /* default */],
    beforeEnter: ifAuthenticated
  }]
}));

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProfileSetting = function ProfileSetting() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 326));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next('/');
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '',
  name: 'ProfileSet',
  component: ProfileSetting,
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_router_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__manage_router_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dasboard_router_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__support_router_js__ = __webpack_require__(194);
var UpdateBot = function UpdateBot() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 349));
};
var ListBot = function ListBot() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 350));
};
var BuildHome = function BuildHome() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 351));
};
var DashboardHome = function DashboardHome() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 352));
};
var ManageHome = function ManageHome() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 353));
};
var SupportHome = function SupportHome() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 213));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next();
    return;
  }
  next();
};






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '',
  name: 'listBot',
  meta: {
    title: 'List App - Application Msl App'
  },
  component: ListBot,
  beforeEnter: ifAuthenticated
}, {
  path: 'support',
  meta: {
    title: 'support'
  },
  component: SupportHome,
  children: __WEBPACK_IMPORTED_MODULE_3__support_router_js__["a" /* default */],
  beforeEnter: ifAuthenticated
}, {
  path: ':id',
  name: 'updateBot',
  component: UpdateBot,
  meta: {
    title: 'update your App'
  },
  children: [{
    path: 'build',
    component: BuildHome,
    meta: {
      title: 'build'
    },
    children: __WEBPACK_IMPORTED_MODULE_0__build_router_js__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: 'dashboard',
    meta: {
      title: 'dashboard'
    },
    component: DashboardHome,
    children: __WEBPACK_IMPORTED_MODULE_2__dasboard_router_js__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: 'manage',
    meta: {
      title: 'manage'
    },
    component: ManageHome,
    children: __WEBPACK_IMPORTED_MODULE_1__manage_router_js__["a" /* default */],
    beforeEnter: ifAuthenticated
  }]

}]);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intent_router_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entity_router_js__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__review_router_js__ = __webpack_require__(287);
var IntentHome = function IntentHome() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 332));
};
var EntitiesHome = function EntitiesHome() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 333));
};
var ReviewHome = function ReviewHome() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 334));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next();
    return;
  }
  next();
};





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'intents',
  component: IntentHome,
  meta: {
    title: 'build'
  },
  children: __WEBPACK_IMPORTED_MODULE_0__intent_router_js__["a" /* default */],
  beforeEnter: ifAuthenticated
}, {
  path: 'review',
  component: ReviewHome,
  meta: {
    title: 'build'
  },
  children: __WEBPACK_IMPORTED_MODULE_2__review_router_js__["a" /* default */],
  beforeEnter: ifAuthenticated
}, {
  path: 'entities',
  component: EntitiesHome,
  meta: {
    title: 'build'
  },
  children: __WEBPACK_IMPORTED_MODULE_1__entity_router_js__["a" /* default */],
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var IntentHome = function IntentHome() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 327));
};
var UtteranceList = function UtteranceList() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 328));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next('/');
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '',
  name: 'intentHome',
  meta: {
    title: 'intents',
    subtitle: 'intents'
  },
  component: IntentHome,
  beforeEnter: ifAuthenticated
}, {
  path: ':name',
  name: 'utternaceList',
  meta: {
    title: 'intents',
    subtitle: 'intents'
  },
  component: UtteranceList,
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EntitiesHome = function EntitiesHome() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 329));
};
var EntityUpdate = function EntityUpdate() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 330));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next();
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '',
  name: 'entityHome',
  meta: {
    title: 'entities',
    subtitle: 'entities'
  },
  component: EntitiesHome,
  beforeEnter: ifAuthenticated
}, {
  path: ':name',
  name: 'updateEntity',
  meta: {
    title: 'entities',
    subtitle: 'entities'
  },
  component: EntityUpdate,
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ReviewHome = function ReviewHome() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 331));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '',
  name: 'ReviewHome',
  meta: {
    title: 'review'
  },
  // beforeEnter(to, from, next) {
  //   document.title = to.meta.title
  // },
  component: ReviewHome
}]);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// const ManageHome = () => import('@/components/Manage/manage.bot.template.vue')
var GeneralComponent = function GeneralComponent() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 335));
};
var EndPointComponent = function EndPointComponent() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 336));
};
var CollaboratComponent = function CollaboratComponent() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 337));
};
var PublishComponent = function PublishComponent() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 338));
};
var VersionComponent = function VersionComponent() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 339));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next('/');
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'general',
  name: 'GeneralComponent',
  meta: {
    title: 'manage',
    subtitle: 'generalmanage'
  },
  component: GeneralComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'endpoint',
  name: 'EndPointComponent',
  meta: {
    title: 'manage',
    subtitle: 'manage'
  },
  component: EndPointComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'collaborator',
  name: 'CollaboratComponent',
  meta: {
    title: 'manage',
    subtitle: 'manage'
  },
  component: CollaboratComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'publish',
  name: 'PublishComponent',
  meta: {
    title: 'manage',
    subtitle: 'manage'
  },
  component: PublishComponent,
  beforeEnter: ifAuthenticated
}, {
  path: 'version',
  name: 'VersionComponent',
  meta: {
    title: 'manage',
    subtitle: 'manage'
  },
  component: VersionComponent,
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EndPointState = function EndPointState() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 340));
};
var UsageMetrics = function UsageMetrics() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 341));
};
var DetailedModelView = function DetailedModelView() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 342));
};
var ConversationLog = function ConversationLog() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 343));
};
var ConversationMetrics = function ConversationMetrics() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 344));
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token);
    next();
    return;
  }
  next();
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'EndPointState',
  name: 'EndPointState',
  meta: {
    title: 'dashboard',
    subtitle: 'EndPointState'
  },
  component: EndPointState,
  beforeEnter: ifAuthenticated
}, {
  path: 'usageMetrics',
  name: 'usageMetrics',
  meta: {
    title: 'dashboard',
    subtitle: 'usageMetrics'
  },
  component: UsageMetrics,
  beforeEnter: ifAuthenticated
}, {
  path: 'DetailedModelView',
  name: 'DetailedModelView',
  meta: {
    title: 'dashboard',
    subtitle: 'DetailedModelView'
  },
  component: DetailedModelView,
  beforeEnter: ifAuthenticated
}, {
  path: 'conversationLog',
  name: 'conversationLog',
  meta: {
    title: 'dashboard',
    subtitle: 'conversationLog'
  },
  component: ConversationLog,
  beforeEnter: ifAuthenticated
}, {
  path: 'conversationMetrics',
  name: 'conversationMetrics',
  meta: {
    title: 'dashboard',
    subtitle: 'conversationMetrics'
  },
  component: ConversationMetrics,
  beforeEnter: ifAuthenticated
}]);

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DocumentHome = function DocumentHome() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 354));
};
var OverviewDoc = function OverviewDoc() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 355));
};
var StartNuha = function StartNuha() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 356));
};

var BuildDoc = function BuildDoc() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 357));
};
var ManageDoc = function ManageDoc() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 358));
};
var PublishDoc = function PublishDoc() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 359));
};
var EntitiesDoc = function EntitiesDoc() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 360));
};
var TrainDoc = function TrainDoc() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 361));
};
var TestDoc = function TestDoc() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 362));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'document',
  name: 'documentation',
  meta: {
    title: 'document',
    subtitle: 'document'
  },
  component: DocumentHome
}, {
  path: 'TestDoc',
  name: 'doc-test',
  meta: {
    title: 'TestDoc',
    subtitle: 'TestDoc'
  },
  component: TestDoc
}, {
  path: 'TrainDoc',
  name: 'doc-train',
  meta: {
    title: 'TrainDoc',
    subtitle: 'TrainDoc'
  },
  component: TrainDoc
}, {
  path: 'EntitiesDoc',
  name: 'doc-entities',
  meta: {
    title: 'EntitiesDoc',
    subtitle: 'EntitiesDoc'
  },
  component: EntitiesDoc
}, {
  path: 'BuildDoc',
  name: 'doc-build',
  meta: {
    title: 'BuildDoc',
    subtitle: 'BuildDoc'
  },
  component: BuildDoc
}, {
  path: 'PublishDoc',
  name: 'doc-pubiish',
  meta: {
    title: 'PublishDoc',
    subtitle: 'PublishDoc'
  },
  component: PublishDoc
}, {
  path: 'OverviewDoc',
  name: 'doc-overview',
  meta: {
    title: 'OverviewDoc',
    subtitle: 'OverviewDoc'
  },
  component: OverviewDoc
}, {
  path: 'StartNuha',
  name: 'doc-startNuha',
  meta: {
    title: 'StartNuha',
    subtitle: 'StartNuha'
  },
  component: StartNuha
}, {
  path: 'ManageDoc',
  name: 'doc-manage',
  meta: {
    title: 'ManageDoc',
    subtitle: 'ManageDoc'
  },
  component: ManageDoc
}]);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_store_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_store_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bot_store_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conversation_store_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entities_store_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__intent_store_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__language_store_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__expression_store_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__support_store_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contact_store_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__newsletter_store_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dashbord_store_js__ = __webpack_require__(306);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);













/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    Newsletter: __WEBPACK_IMPORTED_MODULE_12__newsletter_store_js__["a" /* default */],
    SupportStore: __WEBPACK_IMPORTED_MODULE_10__support_store_js__["a" /* default */],
    DashbordStore: __WEBPACK_IMPORTED_MODULE_13__dashbord_store_js__["a" /* default */],
    ContactStore: __WEBPACK_IMPORTED_MODULE_11__contact_store_js__["a" /* default */],
    AuthStore: __WEBPACK_IMPORTED_MODULE_2__auth_store_js__["a" /* default */],
    UserStore: __WEBPACK_IMPORTED_MODULE_3__user_store_js__["a" /* default */],
    BotStore: __WEBPACK_IMPORTED_MODULE_4__bot_store_js__["a" /* default */],
    ConversationStore: __WEBPACK_IMPORTED_MODULE_5__conversation_store_js__["a" /* default */],
    EntityStore: __WEBPACK_IMPORTED_MODULE_6__entities_store_js__["a" /* default */],
    IntentStore: __WEBPACK_IMPORTED_MODULE_7__intent_store_js__["a" /* default */],
    LanguageStore: __WEBPACK_IMPORTED_MODULE_8__language_store_js__["a" /* default */],
    ExpressionStore: __WEBPACK_IMPORTED_MODULE_9__expression_store_js__["a" /* default */]
  }
}));

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_users_service_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_store_js__ = __webpack_require__(195);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: {},
    users: []
  },
  getters: {
    getUser: function getUser(state) {
      return state.user;
    }
  },
  mutations: {
    setUser: function setUser(state, user) {
      state.user = user;
    }
  },
  actions: {
    setUser: function setUser(context) {
      var user = __WEBPACK_IMPORTED_MODULE_1__auth_store_js__["a" /* default */].getters.getCurrentUser();
      context.commit('setUser', user);
    }
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__ = __webpack_require__(21);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    bot: {},
    bots: [],
    domaines: []
  },
  getters: {
    getAllBots: function getAllBots(state) {
      return state.bots;
    },
    getBot: function getBot(state) {
      return state.bot;
    },
    getdomaines: function getdomaines(state) {
      return state.domaines;
    }
  },
  mutations: {
    setAllInfoBotsByUser: function setAllInfoBotsByUser(state, bots) {
      state.bots = bots;
    },
    setSelectedBot: function setSelectedBot(state, bot) {
      state.bot = bot;
    },
    setBotById: function setBotById(state, bot) {
      state.bot = bot;
    },
    setDomaine: function setDomaine(state, bot) {
      state.domaines = bot;
    },
    addBot: function addBot(state, bot) {
      state.bot = bot;
      state.bots.splice(0, 0, bot);
    },
    updateList: function updateList(state, bot) {
      state.bots.splice(0, 0, bot);
    },
    updateBot: function updateBot(state, bot) {
      state.bot = bot;
    },
    updateBotSwitch: function updateBotSwitch(state, bot) {
      state.bot = bot;
    },
    updateBotDomaine: function updateBotDomaine(state, bot) {
      state.bot = bot;
    }
  },
  actions: {
    setAllInfoBotsByUser: function setAllInfoBotsByUser(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var bts, infoBots;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["e" /* getBotsByUser */])();

              case 2:
                bts = _context.sent;
                infoBots = new Array();

                bts.forEach(function (element) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["d" /* getBotById */])(element._id).then(function (data) {
                    infoBots.splice(0, 0, data);
                  });
                });
                context.commit('setAllInfoBotsByUser', infoBots);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setSelectedBot: function setSelectedBot(context, bot) {
      context.commit('setSelectedBot', bot);
    },
    setBotById: function setBotById(context, id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var bot;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["d" /* getBotById */])(id);

              case 2:
                bot = _context2.sent;

                context.commit('setBotById', bot);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setDomaine: function setDomaine(context) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var bot;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["f" /* getdomaine */])();

              case 2:
                bot = _context3.sent;

                context.commit('setDomaine', bot);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addBot: function addBot(context, bot) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newbot;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["a" /* addBot */])(bot);

              case 2:
                newbot = _context4.sent;

                context.commit('addBot', newbot);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    updateBot: function updateBot(context, bot) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var upBot;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["i" /* updateBot */])(bot);

              case 2:
                upBot = _context5.sent;

                context.commit('updateBot', upBot);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    updateBotSwitch: function updateBotSwitch(context, bot) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var upBot;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["k" /* updateBotSwitch */])(bot);

              case 2:
                upBot = _context6.sent;

                context.commit('updateBotSwitch', upBot);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateBotDomaine: function updateBotDomaine(context, bot) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var upBot;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["j" /* updateBotDomaine */])(bot);

              case 2:
                upBot = _context7.sent;

                context.commit('updateBotDomaine', upBot);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    deleteBot: function deleteBot(context, id) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var upbot, list, infoBots;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["b" /* deleteBot */])(id);

              case 2:
                upbot = _context8.sent;
                list = upbot.bot;
                infoBots = new Array();

                list.forEach(function (element) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["d" /* getBotById */])(element._id).then(function (data) {
                    infoBots.splice(0, 0, data);
                  });
                });
                context.commit('setAllInfoBotsByUser', infoBots);

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    train: function train(context, obj) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var train;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log('test bot ', obj);
                _context9.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["h" /* trainBot */])(obj);

              case 3:
                train = _context9.sent;

                context.commit('updateBot', train);

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    setpublish: function setpublish(context, obj) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var publish;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_bot_service_js__["g" /* publishBot */])(obj);

              case 2:
                publish = _context10.sent;

                context.commit('updateBot', publish);

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bot_service_js__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    conversation: {},
    conversations: [],
    messages: [],
    message: {},
    train: '',
    publish: ''
  },
  getters: {
    getAllConversation: function getAllConversation(state) {
      return state.conversations;
    },
    getConversationAll: function getConversationAll(state) {
      return state.conversations;
    },
    getConversation: function getConversation(state) {
      return state.conversation;
    },
    getMessages: function getMessages(state) {
      return state.conversation.messages;
    },
    getMessagesAll: function getMessagesAll(state) {
      return state.messages;
    },
    getuttrnaceAll: function getuttrnaceAll(state) {
      return state.messages;
    },
    getTrain: function getTrain(state) {
      return state.train;
    },
    getPublish: function getPublish(state) {
      return state.publish;
    }
  },

  mutations: {
    setAllConversation: function setAllConversation(state, convs) {
      state.conversations = convs;
    },
    updateMessages: function updateMessages(state, convs) {
      state.messages = convs;
    },
    setAllMessages: function setAllMessages(state, convs) {
      state.messages = convs;
    },
    setAllConve: function setAllConve(state, convs) {
      state.conversations = convs;
    },
    setConversationById: function setConversationById(state, newconv) {
      state.conversation = newconv;
    },
    addConversation: function addConversation(state, newconv) {
      state.conversation = newconv;
    },
    addMessage: function addMessage(state, msgs) {
      state.conversation = msgs;
    },
    setTrain: function setTrain(state, train) {
      state.train = train;
    },
    setpublish: function setpublish(state, publish) {
      state.publish = publish;
    },
    clearCurrentConversation: function clearCurrentConversation(state, obj) {
      state.conversation = obj;
    }
  },
  actions: {
    clearConversation: function clearConversation(context, obj) {
      context.commit('clearCurrentConversation', obj);
    },
    setAllMessages: function setAllMessages(context, idBot) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var convs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["f" /* getuttrnaceAll */])(idBot);

              case 2:
                convs = _context.sent;


                context.commit('setAllMessages', convs);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setAllConversation: function setAllConversation(context) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var convs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["d" /* getConversationAll */])();

              case 2:
                convs = _context2.sent;

                context.commit('setAllConversation', convs);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setAllConve: function setAllConve(context, id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var conversation;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["c" /* getAllConversationbyBot */])(id);

              case 2:
                conversation = _context3.sent;

                context.commit('setAllConve', conversation);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setConversationById: function setConversationById(context, id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var conv;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["e" /* getConversationById */])(id);

              case 2:
                conv = _context4.sent;

                context.commit('setConversationById', conv);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addConversation: function addConversation(context, conv) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var newConversation;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["a" /* addConversation */])(conv);

              case 2:
                newConversation = _context5.sent;

                context.commit('addConversation', newConversation);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    addMessage: function addMessage(context, conv) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var convMs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["b" /* addMessage */])(conv);

              case 2:
                convMs = _context6.sent;

                context.commit('addMessage', convMs);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateMessages: function updateMessages(context, obj) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var msgsR;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["j" /* updateMessages */])(obj);

              case 2:
                msgsR = _context7.sent;

                context.commit('setAllMessages', msgsR);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    removeMessages: function removeMessages(context, obj) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var msgsR;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_conversation_service_js__["h" /* removeMessages */])(obj);

              case 2:
                msgsR = _context8.sent;

                console.log("stoore remove ", msgsR);
                context.commit('setAllMessages', msgsR);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    }
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_bot_service_js__ = __webpack_require__(21);






/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    entity: {},
    entities: [],
    childrens: [],
    synonyms: []
  },
  getters: {
    getAllEntities: function getAllEntities(state) {
      return state.entities;
    },
    getEntity: function getEntity(state) {
      return state.entity;
    },
    getChildren: function getChildren(state) {
      return state.childrens;
    },
    getSynonyms: function getSynonyms(state) {
      return state.synonyms;
    }
  },
  mutations: {
    setAllEntities: function setAllEntities(state, entities) {
      state.entities = entities;
    },
    setEntityById: function setEntityById(state, entity) {
      state.entity = entity;
    },
    addEntity: function addEntity(state, newEntity) {
      state.entity = newEntity;
      state.entities.splice(0, 0, newEntity);
    },
    updateEntity: function updateEntity(state, newEntity) {
      // state.entity = newEntity

      state.entities = newEntity;
    },
    addSynonyms: function addSynonyms(state, entity) {
      state.entity = entity;
    },
    setContent: function setContent(state, child) {
      state.entity.children = child;
    },
    addContent: function addContent(state, children) {
      state.entity.children = children;
    },
    setChildrens: function setChildrens(state, chld) {
      state.entity.children.splice(0, 0, chld);
    },
    setSynonyms: function setSynonyms(state, synonyms) {
      state.synonyms = synonyms;
    },
    setAllEnts: function setAllEnts(state, entities) {
      state.entities = entities;
    },
    setAllEntDash: function setAllEntDash(state, entities) {
      state.entities = entities;
    }
  },
  actions: {
    setAllEnts: function setAllEnts(context, id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var entities, infoEntities;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["f" /* getAllEntitiesByBot */])(id);

              case 2:
                entities = _context.sent;
                infoEntities = new Array();


                if ((typeof entities === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(entities)) != undefined && entities != null && entities.length && entities.length > 0) {
                  entities.forEach(function (el) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["j" /* getEntityById */])(el._id).then(function (data) {
                      infoEntities.splice(0, 0, data);
                    });
                  });
                }
                context.commit('setAllEnts', infoEntities);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setAllEntDash: function setAllEntDash(context, id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var entities;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["f" /* getAllEntitiesByBot */])(id);

              case 2:
                entities = _context2.sent;

                context.commit('setAllEntDash', entities);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setAllEntities: function setAllEntities(context) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var entities;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["g" /* getAllEntity */])();

              case 2:
                entities = _context3.sent;

                context.commit('setAllEntities', entities);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setAllEntityByBot: function setAllEntityByBot(context, idBot) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var listEntities;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["f" /* getAllEntitiesByBot */])(idBot);

              case 2:
                listEntities = _context4.sent;

                context.commit('setAllEntities', listEntities);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    setEntityById: function setEntityById(context, id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var entity;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["j" /* getEntityById */])(id);

              case 2:
                entity = _context5.sent;

                context.commit('setEntityById', entity);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    addEntity: function addEntity(context, entity) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var bot, newentity;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__api_bot_service_js__["d" /* getBotById */])(entity.bot._id);

              case 2:
                bot = _context6.sent;

                entity.bot.name = bot.name;
                _context6.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["b" /* addEntity */])(entity);

              case 6:
                newentity = _context6.sent;

                context.commit('addEntity', newentity);

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    addSynonyms: function addSynonyms(context, entity) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var entityS;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["c" /* addSynonyms */])(entity);

              case 2:
                entityS = _context7.sent;

                context.commit('addSynonyms', entityS);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    addContent: function addContent(context, entity) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var entityC;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log("########## store add content", entity);
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["a" /* addContent */])(entity);

              case 3:
                entityC = _context8.sent;

                console.log("######### store entityC", entityC);
                context.commit('addContent', entityC[0].children);

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    setChildrens: function setChildrens(context, chld) {
      context.commit('setChildrens', chld);
    },
    deleteEntity: function deleteEntity(context, id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var newEntities;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["e" /* deleteEntity */])(id);

              case 2:
                newEntities = _context9.sent;

                context.commit('setAllEntities', newEntities);

              case 4:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    updateEntity: function updateEntity(context, entity) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var upEntity;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["l" /* updateEntity */])(entity);

              case 2:
                upEntity = _context10.sent;

                context.commit('updateEntity', upEntity);

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    setSynonyms: function setSynonyms(context, idBot) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var listSynonyms;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["h" /* getAllSynonyms */])(idBot);

              case 2:
                listSynonyms = _context11.sent;

                console.log("########### listSynonyms ##########", listSynonyms);
                context.commit('setSynonyms', listSynonyms);

              case 5:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    deleteContent: function deleteContent(context, content) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var childs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["d" /* deleteContent */])(content);

              case 2:
                childs = _context12.sent;

                context.commit('setContent', childs.children);

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    updateContent: function updateContent(context, child) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var childs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_entities_service_js__["k" /* updateContent */])(child);

              case 2:
                childs = _context13.sent;

                context.commit('setContent', childs);

              case 4:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13);
      }))();
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bot_service_js__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    intent: {},
    intents: [],
    intentsPub: []
  },
  getters: {
    getIntent: function getIntent(state) {
      return state.intent;
    },
    getAllIntent: function getAllIntent(state) {
      return state.intents;
    },
    getAllIntentsPublic: function getAllIntentsPublic(state) {
      return state.intentsPub;
    }
  },
  mutations: {
    // getAllIntentsPublic(state, intents){
    //   state.intentsPub = intents
    // },
    setAllIntentsPublic: function setAllIntentsPublic(state, intents) {
      state.intentsPub = intents;
    },
    setAllIntents: function setAllIntents(state, intents) {
      state.intents = intents;
    },
    setIntent: function setIntent(state, intent) {
      state.intent = intent;
    },
    addIntent: function addIntent(state, newintent) {
      state.intent = newintent;
      state.intents.splice(0, 0, newintent);
    },
    addIntentListPublic: function addIntentListPublic(state, newintent) {
      state.intent = newintent;
      state.intents.splice(0, 0, newintent);
    },
    updateIntent: function updateIntent(state, upIntent) {
      state.intent = upIntent;
    }
  },
  actions: {
    setAllIntents: function setAllIntents(context, id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var intents, infoIntents;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["e" /* getAllIntentsbyBot */])(id);

              case 2:
                intents = _context.sent;
                infoIntents = new Array();

                console.log('intents', intents);
                console.log('infoIntents', infoIntents);
                intents.forEach(function (el) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["f" /* getIntentById */])(el._id).then(function (data) {
                    infoIntents.splice(0, 0, data);
                  });
                });
                context.commit('setAllIntents', infoIntents);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setAllIntentsPublic: function setAllIntentsPublic(context) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var intents;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["d" /* getAllIntentsPublic */])();

              case 2:
                intents = _context2.sent;


                context.commit('setAllIntentsPublic', intents);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setIntent: function setIntent(context, id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var ut;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["f" /* getIntentById */])(id);

              case 2:
                ut = _context3.sent;

                context.commit('setIntent', ut);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addIntent: function addIntent(context, intent) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var bot, newintent, intents;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_bot_service_js__["d" /* getBotById */])(intent.bot._id);

              case 2:
                bot = _context4.sent;

                intent.bot.name = bot.name;
                _context4.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["a" /* addIntent */])(intent);

              case 6:
                newintent = _context4.sent;

                context.commit('addIntent', newintent);

                if (!intent.public) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["d" /* getAllIntentsPublic */])();

              case 11:
                intents = _context4.sent;

                context.commit('setAllIntentsPublic', intents);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addIntentListPublic: function addIntentListPublic(context, intent) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var bot, newintent, intents;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_bot_service_js__["d" /* getBotById */])(intent.intent.bot._id);

              case 2:
                bot = _context5.sent;

                intent.bot.name = bot.name;
                _context5.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["b" /* addIntentListPublic */])(intent);

              case 6:
                newintent = _context5.sent;

                context.commit('addIntentListPublic', newintent);

                if (!intent.public) {
                  _context5.next = 13;
                  break;
                }

                _context5.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["d" /* getAllIntentsPublic */])();

              case 11:
                intents = _context5.sent;

                context.commit('setAllIntentsPublic', intents);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    updateIntent: function updateIntent(context, intent) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var upIntent, intents;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["g" /* updateIntent */])(intent);

              case 2:
                upIntent = _context6.sent;

                context.commit('updateIntent', upIntent);

                if (!intent.public) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["d" /* getAllIntentsPublic */])();

              case 7:
                intents = _context6.sent;

                context.commit('setAllIntentsPublic', intents);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    deleteIntent: function deleteIntent(context, obj) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var upIntent;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_intent_service_js__["c" /* deleteIntent */])(obj);

              case 2:
                upIntent = _context7.sent;

                context.commit('setAllIntents', upIntent);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    }
  }
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_language_service_js__ = __webpack_require__(299);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    language: {},
    languages: []
  },
  getters: {
    getlanguage: function getlanguage(state) {
      return state.language;
    },
    getAlllanguage: function getAlllanguage(state) {
      return state.languages;
    }
  },
  mutations: {
    setLanguages: function setLanguages(state, langs) {
      state.languages = langs;
    },
    setLanguageById: function setLanguageById(state, lang) {
      state.language = lang;
    }
  },
  actions: {
    setLanguages: function setLanguages(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var langs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_language_service_js__["a" /* getAllLanguage */])();

              case 2:
                langs = _context.sent;

                context.commit('setLanguages', langs);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setLanguageById: function setLanguageById(context, id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var lang;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_language_service_js__["b" /* getLanguageById */])(id);

              case 2:
                lang = _context2.sent;

                context.commit('setLanguageById', lang);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLanguageById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_production_json__);







var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/language';


if (true) {
  url = __WEBPACK_IMPORTED_MODULE_6__config_production_json___default.a.host + path + '/language';
}

var getAllLanguage = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/all').then(function (response) {
                var langs = response.data.data;
                resolve(langs);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getAllLanguage() {
    return _ref.apply(this, arguments);
  };
}();

var getLanguageById = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var lang = response.data.data;
                resolve(lang);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getLanguageById(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__ = __webpack_require__(222);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    expression: {},
    expressions: [],
    synonyms: []
  },
  getters: {
    getExpression: function getExpression(state) {
      return state.expression;
    },
    getAllExpression: function getAllExpression(state) {
      return state.expressions;
    }
  },
  mutations: {
    setExpression: function setExpression(state, express) {
      state.expression = express;
    },
    setExpressionByintent: function setExpressionByintent(state, expressions) {
      state.expressions = expressions;
    },
    setAllExpressionByBot: function setAllExpressionByBot(state, expressions) {
      state.expressions = expressions;
    },
    setAllExpression: function setAllExpression(state, expres) {
      state.expressions = expres;
    },
    addExpression: function addExpression(state, expr) {
      state.expression = expr;
      state.expressions.splice(0, 0, expr);
    },
    AddListUtterance: function AddListUtterance(state, expr) {
      state.expression = expr;
      state.expressions.splice(0, 0, expr);
    }
  },
  actions: {
    setExpression: function setExpression(context, id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var express;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["f" /* getExpressionById */])(id);

              case 2:
                express = _context.sent;

                context.commit('setExpression', express);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setAllExpression: function setAllExpression(context) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var expressions;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["c" /* getAllExpression */])();

              case 2:
                expressions = _context2.sent;

                console.log("teeeeeeeeest", expressions);
                console.log('test expressionsssssss', expressions.source);
                context.commit('setAllExpression', expressions);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setAllExpressionByBot: function setAllExpressionByBot(context, id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var expression;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["e" /* getAllExpressionBybot */])(id);

              case 2:
                expression = _context3.sent;


                context.commit('setAllExpressionByBot', expression);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addExpression: function addExpression(context, express) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var expr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["b" /* addExpression */])(express);

              case 2:
                expr = _context4.sent;

                console.log('test expression', expr);
                context.commit('setExpressionByintent', expr.expressions);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    setExpressionByintent: function setExpressionByintent(context, id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var exprs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["d" /* getAllExpressionByIntents */])(id);

              case 2:
                exprs = _context5.sent;

                console.log("##################setExpressionByintent##############", exprs);
                context.commit('setAllExpression', exprs);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    deleteUtterance: function deleteUtterance(context, id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var upExpress;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("heeey store delete", id);
                _context6.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["g" /* removeUtterance */])(id);

              case 3:
                upExpress = _context6.sent;

                context.commit('setExpressionByintent', upExpress);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    updateUtterance: function updateUtterance(context, utt) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var upUtterance;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["h" /* updateUtterance */])(utt);

              case 2:
                upUtterance = _context7.sent;

                context.commit('setExpression', upUtterance);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    AddListUtterance: function AddListUtterance(context, utrList) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var utrs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_expression_service_js__["a" /* AddListUtterance */])(utrList);

              case 2:
                utrs = _context8.sent;

                console.log("test utrs store", utrs);
                context.commit('setExpressionByintent', utrs);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    }
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_support_service_js__ = __webpack_require__(302);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    ticket: {},
    tickets: []
  },
  getters: {
    getTickets: function getTickets(state) {
      return state.ticket;
    },
    getAllTickets: function getAllTickets(state) {
      return state.tickets;
    },
    getAllTicketByUser: function getAllTicketByUser(state) {
      return state.tickets;
    }
  },
  mutations: {
    setAllTickets: function setAllTickets(state, tickets) {
      state.tickets = tickets;
    },
    setAllTicketsByuser: function setAllTicketsByuser(state, tickets) {
      state.tickets = tickets;
    },
    setTicket: function setTicket(state, ticket) {
      state.ticket = ticket;
    },
    addTicket: function addTicket(state, newticket) {
      state.ticket = newticket;
      state.tickets.splice(0, 0, newticket);
    },
    updateTicket: function updateTicket(state, ticket) {
      state.ticket = ticket;
    }
  },
  actions: {
    getAllTickets: function getAllTickets(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var tickets, infoTickets;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["b" /* getAllTicket */])();

              case 2:
                tickets = _context.sent;
                infoTickets = new Array();


                tickets.forEach(function (el) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["d" /* getTicketById */])(el._id).then(function (data) {
                    infoTickets.splice(0, 0, data);
                  });
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAllTicketByUser: function getAllTicketByUser(context) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var tickets, infoTickets;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["c" /* getAllTicketByUser */])();

              case 2:
                tickets = _context2.sent;
                infoTickets = new Array();


                tickets.forEach(function (el) {
                  Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["d" /* getTicketById */])(el._id).then(function (data) {
                    infoTickets.splice(0, 0, data);
                  });
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setTicket: function setTicket(context, id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var ut;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["d" /* getTicketById */])(id);

              case 2:
                ut = _context3.sent;

                context.commit('setTicket', ut);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    addTicketUser: function addTicketUser(context, ticket) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newticket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["a" /* addTickets */])(ticket);

              case 2:
                newticket = _context4.sent;

                context.commit('addTicket', newticket);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    updateTicket: function updateTicket(context, ticket) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var upTicket;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_support_service_js__["e" /* updateTicket */])(ticket);

              case 2:
                upTicket = _context5.sent;

                context.commit('updateTicket', upTicket);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTicketById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAllTicketByUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateTicket; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_production_json__);






var urlSecure = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure';


var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure/support';



if (true) {
  url = __WEBPACK_IMPORTED_MODULE_7__config_production_json___default.a.host + path + '/secure/support';
}

var getTicketById = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/' + id).then(function (response) {
                var ticket = response.data.data;
                resolve(ticket);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getTicketById(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getTicketById(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getAllTicket = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/all').then(function (response) {
                var tickets = response.data.data;
                resolve(tickets);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllTicket());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getAllTicket() {
    return _ref2.apply(this, arguments);
  };
}();
var getAllTicketByUser = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log("api service fet all tickets by user");
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/get/user/all').then(function (response) {
                var tickets = response.data.data;
                resolve(tickets);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_6__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getAllTicketByUser());
                  }).catch(function (err) {
                    return reject(err);
                  });
                }
              });
            }));

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getAllTicketByUser() {
    return _ref3.apply(this, arguments);
  };
}();

var addTickets = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(ticket) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("****** service ********", ticket);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/add', ticket).then(function (response) {
                var ticket = response.data.data;
                resolve(ticket);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function addTickets(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var updateTicket = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(ticket) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log("################## servive ticket._id####### ", ticket._id);
              console.log("################## servive ticket####### ", ticket);

              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url + '/update/' + ticket._id, ticket).then(function (response) {
                var upIntent = response.data.data;
                resolve(upIntent);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function updateTicket(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_contact_service_js__ = __webpack_require__(219);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    contact: {}
  },
  getters: {},
  mutations: {
    contactMessage: function contactMessage(state, newcontact) {
      state.contact = newcontact;
    }
  },
  actions: {
    contactMessage: function contactMessage(context, cntact) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contact;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("je suis dans le store  contact message");
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_contact_service_js__["a" /* contactMessage */])(cntact);

              case 3:
                contact = _context.sent;

                context.commit('contactMessage', contact);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_newsletter_service_js__ = __webpack_require__(305);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},

  mutations: {},
  actions: {
    registerNewsletter: function registerNewsletter(context, user) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("newsletter store register \n", user);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_newsletter_service_js__["a" /* registerNewsletter */])(user);

              case 3:
                usr = _context.sent;

                context.commit('registerNewsletter', usr);
                return _context.abrupt('return', usr);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerNewsletter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_production_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(3);






var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path;
var urlSecure = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure';



if (true) {
  var _url = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path;
  var _urlSecure = __WEBPACK_IMPORTED_MODULE_4__config_dev_json___default.a.host + path + '/secure';
}

var registerNewsletter = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(user) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url + '/newsletter/register', user).then(function (response) {
                console.log("response api", response.data.data);
                localStorage.token = response.data.data.token;
                var token = localStorage.token;
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                resolve(response.data.data.user);
              }).catch(function (err) {
                var propsData = {
                  direction: "right",
                  duration: 1500
                };
                console.log('test err', err.response.data.errors);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$notif.show(propsData = {
                  title: "Error !",
                  message: err.response.data.errors,
                  type: "danger"
                });
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function registerNewsletter(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dashbord_service_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bot_service_js__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dashbord: {},
    dashbords: [],
    dashbordsPub: []
  },
  getters: {
    getdashbord: function getdashbord(state) {
      return state.dashbord;
    },
    getAlldashbord: function getAlldashbord(state) {
      return state.dashbords;
    }
  },
  mutations: {
    setAlldashbords: function setAlldashbords(state, dashbords) {
      state.dashbords = dashbords;
    },
    setdashbord: function setdashbord(state, dashbord) {
      state.dashbord = dashbord;
    }
  },
  actions: {
    setAlldashbords: function setAlldashbords(context, id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var dashbords;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("test store dash ", id);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_dashbord_service_js__["a" /* getAlldashbordsbyBot */])(id);

              case 3:
                dashbords = _context.sent;

                console.log("test dasbords", dashbords);

                context.commit('setAlldashbords', dashbords);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateUtteranceDash: function updateUtteranceDash(context, utt) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var upUtterance;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_dashbord_service_js__["c" /* updateUtteranceDash */])(utt);

              case 2:
                upUtterance = _context2.sent;

                context.commit('updateUtteranceDash', upUtterance);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifcation_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4055da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifcation_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifcation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4055da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifcation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition,"mode":"in-out","appear":"","appear-active-class":_vm.enterClass,"enter-active-class":_vm.enterClass,"leave-active-class":_vm.leaveClass},on:{"after-leave":_vm.afterLeave}},[(_vm.show)?_c('div',{class:['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']},[_c('button',{staticClass:"delete touchable",on:{"click":function($event){_vm.closedByUser()}}}),_vm._v(" "),(_vm.title)?_c('div',{staticClass:"title is-5"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(198);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0c89b7e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0c89b7e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(! _vm.isHidden),expression:"! isHidden"}],staticClass:"notification",class:_vm.type},[(_vm.isCloseable)?_c('button',{staticClass:"delete",on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUserById */
/* unused harmony export uploadFileExcel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uploadImageProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateUserInfo; });
/* unused harmony export deleteUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePassword; });
/* unused harmony export getCountries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_service_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_dev_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_dev_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_dev_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_production_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_production_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(3);







var path = '/api/v1';
var url = __WEBPACK_IMPORTED_MODULE_5__config_dev_json___default.a.host + path + '/secure';
var urlSecure = __WEBPACK_IMPORTED_MODULE_5__config_dev_json___default.a.host + path + '/secure';
var urlUp = __WEBPACK_IMPORTED_MODULE_5__config_dev_json___default.a.host + path + '/file';



if (true) {
  url = __WEBPACK_IMPORTED_MODULE_6__config_production_json___default.a.host + path + '/secure';
}

var getUserById = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(urlSecure + '/get/' + id).then(function (response) {
                var user = response.data.data;
                resolve(user);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_4__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(getUserById(id));
                  }).catch(function (err) {
                    return reject(err);
                  });
                } else {
                  reject(err);
                }
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getUserById(_x) {
    return _ref.apply(this, arguments);
  };
}();

// upload nrmlm tkoun fi upload file // serviceuploadfile intent
var uploadFileExcel = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(formData, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('tets data', formData);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + '/upload/' + id, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function (response) {
                console.log('tetst res', response.data.data);
                location.reload();
                resolve(response.data.data);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function uploadFileExcel(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var uploadImageProfile = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(formData, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlUp + "/profile/image/" + id, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(function (response) {
                resolve(response.data.data);
              }).catch(function (err) {
                return reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function uploadImageProfile(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

var updateUserInfo = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('tetst update ', user);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(urlSecure + '/profile/update/' + user._id, user).then(function (response) {
                var user = response.data.data;
                resolve(user);
              }).catch(function (err) {
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_4__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(updateUserInfo(user));
                  }).catch(function (err) {
                    reject(err);
                  });
                } else {
                  reject(err);
                }
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function updateUserInfo(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var deleteUser = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(urlSecure + '/delete', token).then(function (response) {
                resolve(response);
              }).catch(function (err) {
                if (err.repsonse.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_4__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(deleteUser());
                  }).catch(function (err) {
                    reject(err);
                  });
                } else {
                  reject(err);
                }
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function deleteUser(_x7) {
    return _ref5.apply(this, arguments);
  };
}();

var changePassword = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(pwd) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              console.log('test pwd ', pwd);
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(urlSecure + '/profile/changepassword', pwd).then(function (response) {
                console.log('test dtaa', response.data.data);
                var msg = response.data.data;
                resolve(msg);
              }).catch(function (err) {
                console.log('test err mere', err);
                if (err.response.status === 401) {
                  Object(__WEBPACK_IMPORTED_MODULE_4__auth_service_js__["e" /* refresh */])().then(function () {
                    resolve(changePassword(pwd));
                  }).catch(function (err) {
                    return reject(err);
                  });
                } else {
                  console.log('test err', err);
                  var propsData = {
                    direction: "right",
                    duration: 1500
                  };
                  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$notif.show(propsData = {
                    title: "Error !",
                    message: "Check your password !",
                    type: "danger"
                  });
                  reject(err);
                }
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function changePassword(_x8) {
    return _ref6.apply(this, arguments);
  };
}();

var getCountries = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://restcountries.eu/rest/v1/all').then(function (response) {
                var countries = new Array();
                response.data.forEach(function (element) {
                  countries.push(element.name);
                });
                resolve(countries);
              });
            }).catch(function (err) {
              reject(err);
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function getCountries() {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_auth_service_js__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//


var NavbarComponent = function NavbarComponent() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 325));
};


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    NavbarComponent: NavbarComponent
  },
  created: function created() {
    var _this = this;

    if (localStorage.token) {
      Object(__WEBPACK_IMPORTED_MODULE_0__api_auth_service_js__["g" /* setToken */])(localStorage.token);
      this.$store.dispatch('refresh');
      this.$store.dispatch('setLanguages');
      Object(__WEBPACK_IMPORTED_MODULE_0__api_auth_service_js__["e" /* refresh */])(localStorage.token).then(function (response) {
        console.log("test lis ");
        Object(__WEBPACK_IMPORTED_MODULE_0__api_auth_service_js__["b" /* getInfo */])(response).then(function (user) {
          _this.$store.dispatch('setCurrentUser', user);
          _this.$store.dispatch("setAllInfoBotsByUser");
        });
      });
    }
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = {"host":"https://inuha.app","hostnlp":"https://node2.mobilesupportbot.com:5051","upload":"https://node1.mobilesupportbot.com:1235"}

/***/ })

},[224]);


// WEBPACK FOOTER //
// static/js/app.746bb0502f057fa2949a.js